import { useEffect, useState } from 'react'
import { School } from '../../models'

export default function useStudentImageStatus(school, schools) {
  const [status, setStatus] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!school) return

    const chosenSchool = schools.find((item) => item.name.trim() === school.trim())

    if (!chosenSchool) return

    setLoading(true)

    School
      .selectExtra(['studentImageStatus'])
      .find(chosenSchool.id)
      .then((res) => {
        setLoading(false)
        setStatus(res.data.studentImageStatus)
      })
  }, [school])

  return { status, loading }
}
